/* eslint-disable object-curly-newline */
import { useState } from 'preact/hooks';
import PropTypes from 'prop-types';
import AppState from '@state';

import { postOrgContract } from '@api/restricted/org-contracts-api';

import AlertMessage from '@ui-kit/alert/Alert';
import BaseButton from '@ui-kit/buttons/baseButton';
import Box from '@ui-kit/box';
import BreakLine from '@ui-kit/dividers/breakLine';
import AiSummary from '@distinct-components/dataDisplay/aiSummary/AiSummary';
import Icon from '@ui-kit/icon';
import AiIcon from '@assets/icons/ai-icon.svg';
import PrimaryText from '@ui-kit/typography/primaryText';

import { Remarkable } from 'remarkable';

function AddedContractSummaryView({ contractSummary, contractData, contractFile, loadContracts, closeFunction }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const md = new Remarkable();

  const onClickSubmitContractData = () => {
    setIsLoading(true);
    setError(null);

    postOrgContract(AppState.pubOrganization.id.value, contractFile, contractData)
      .then((response) => {
        if (response.status !== 200) {
          setIsLoading(false);
          response.json()
            .then((json) => setError(json.error || response.statusText))
            .catch(() => setError(response.statusText));
        } else {
          loadContracts().then(() => {
            setIsLoading(false);
            closeFunction();
          });
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setError(err.message);
      });
  };

  return (
    <Box>

      <AiSummary
        summary={contractSummary || 'Unable to create summary information'}
      />

      <BreakLine mb="1.25em" mt="1.5em" color="var(--panel-info-border)" />

      <Box className="contract-ai-markdown" mb="1.5rem">
        <Box display="flex" alignItems="center" mb="0.5rem">
          <Icon color="var(--text-primary)" size="0.875rem" mr="0.5rem">
            <AiIcon />
          </Icon>
          <PrimaryText color="var(--text-primary)" lineHeight="1">Full Summary</PrimaryText>
        </Box>
        <Box dangerouslySetInnerHTML={{ __html: md.render(contractData.fullSummary) }} />
      </Box>

      {error && (
      <AlertMessage
        variant="negative"
        message={error}
        mb="1.5em"
        mt="1.5em"
      />
      )}

      {contractData && (
      <BaseButton
        mb="1.5em"
        btnText="Save and Continue"
        fluid
        isLoading={isLoading}
        onClick={onClickSubmitContractData}
      />
      )}
    </Box>
  );
}

AddedContractSummaryView.propTypes = {
  contractSummary: PropTypes.string.isRequired,
  contractData: PropTypes.object.isRequired,
  contractFile: PropTypes.object.isRequired,
  loadContracts: PropTypes.func.isRequired,
  closeFunction: PropTypes.func.isRequired,
};

export default AddedContractSummaryView;
